import React, { Component } from 'react';
import "./reserveABookAdmin.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import ReactHtmlParser from 'react-html-parser';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import Pagination from 'react-js-pagination';
import { connect } from 'react-redux';
import Select from 'react-select';
import ReactToPrint from 'react-to-print';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";

export class ReserveABookForAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addMember: false,
            filterModal: false,


            offset: 0,
            pageIndex: 1,
            limit: 10,
            accessDataList: false,
            successModal: false,

            // VARIABLES TO SELECT FACULTY
            selectedMemberIds: [],

            //VARIABLE TO GET MEMBERS LIST
            membersList: {},
            totalMembers: 0,
            accessMemberList: false,

            isFilterLoading: false,
            AccessionSeriesData: [],
            resourceSearchAccessionSeries: [],
            // selectedDate: "",
            loadingFilterAccessionSeries: false,
            isLoadingAddReserveBook: false,
            GetMultipleAccessionNumberList: [],
            searchMultipleAccessionNumber: [],
            searchAccessionNo: '',

            // filter fields
            filterAccessionSeriesData: [],
            filterSelectedAccessionSeries: [],
            filterAccessionNumberData: [],
            filterSelectedAccesionNumber: [],
            filterSearchAccessionNo: '',
            loadingFilterAccessionNumberData: false,
            loadingFilterAccessionSeriesData: false,
            filterStatus: [],
            searchByUserDetails: "",

            // field validation
            accessionSeriesWarning: '',
            accessionNumberWarning: '',
            // expectedDateWarning: '',

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Accession Details", key: 'accessionDetails' },
                { name: "Resource Title", key: 'resourceTitle' },
                { name: "Resource Author", key: 'resourceAuthor' },
                { name: "Expected Date", key: 'expectedDate' },
                { name: "Added On", key: 'addedOn' },
                { name: "Status", key: 'status' },
                { name: "Queue Number", key: 'queueNumber' }
            ],
        }
    }

    componentDidMount() {
        this.library_getReserveResourceRequests();
        this.apiFilterGetAccessionSeries();

        this.formatCSVExportData('onLoad'); // export data
    }

    //API CALL METHOD TO GET ACCESSION SERIES For Filter
    apiFilterGetAccessionSeries = async () => {
        this.setState({ loadingFilterAccessionSeriesData: true });

        let requestData = {
            "iid": config.institute_id,
            "iidArray": [config.institute_id]
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    label: seriesData?.seriestext,
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    filterAccessionSeriesData: formattedMembers,
                    loadingFilterAccessionSeriesData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingFilterAccessionSeriesData: false
                });
            }
        }
    }

    //API CALL METHOD TO GET MULTIPLE ACCESSION NUMBER for Filter
    getFilterMultipleAccessionNoList = async () => {
        this.setState({ loadingFilterAccessionNumberData: true });

        let filterSelectedAccessionSeries = []
        this.state.filterSelectedAccessionSeries?.map((item) => {
            filterSelectedAccessionSeries.push(item.value)
        })


        let requestData = {
            "iid": config.institute_id,
            "accessionSeriesIdArr": filterSelectedAccessionSeries,
            "searchAccssionSeriesNo": this.state.filterSearchAccessionNo,
            "pageIndex": 1,
            "limitPerPage": 10
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getMultipleAccessionNumber',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getFilterMultipleAccessionNoList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                const formattedMembers = Object.values(apiResult)?.map((data) => ({
                    value: data.resourceId,
                    label: data?.accessionNo,
                }));

                this.setState({
                    filterAccessionNumberData: formattedMembers,
                    loadingFilterAccessionNumberData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession number list. Please try again later.',
                    loadingFilterAccessionNumberData: false
                });
            }
        }
    }

    // API CALL TO GET MEMBERS DATA LIST
    library_getReserveResourceRequests = async () => {

        this.setState({
            accessMemberList: true
        });

        let filterParameter = {
            "searchAccessionNumber": this.state.filterSelectedAccesionNumber?.label || "",
            "searchseries": this.state.filterSelectedAccessionSeries[0]?.value || "",
            "searchERPId": this.state.searchByUserDetails
        }

        let requestData = {
            "iid": config.institute_id,
            "iidArray": [config.institute_id],
            "pageIndex": this.state.pageIndex,
            "limitPerPage": this.state.limit,
            "status": this.state.filterStatus?.value,
            "userRole": "", // config.account,
            "filterParameter": filterParameter
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getReserveResourceRequests',
            requestData,
            "/api/library/library.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_getReserveResourceRequests();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        membersList: apiResult.data,
                        totalMembers: apiResult.totalRecords,
                        accessMemberList: false,
                        addMember: false
                    })
                }
                else {
                    this.setState({
                        membersList: {},
                        totalMembers: 0,
                        accessMemberList: false,

                    })
                }
            } else {
                this.setState({
                    membersList: {},
                    totalMembers: 0,
                    accessMemberList: false,

                })
            }
        }
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    // METHOD TO SELECT LIMIT
    selectLimit = (e) => {
        this.setState({
            limit: e.target.value,
            pageIndex: 1,
            offset: 0,
        }, () => {
            // METHOD CALLED TO GET MEMBER DETAILS
            this.library_getReserveResourceRequests();
        });
    }

    // METHOD TO UPDATE PAGINATION PAGE NUMBER
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit,
            selectedMemberIds: []
        }, () => {
            // METHOD CALLED TO GET MEMBER DETAILS
            this.library_getReserveResourceRequests();
        });
    }

    // CLEAR ALL FILTER
    handleClearAllResourceFilter = () => {
        this.setState({
            filterSelectedAccessionSeries: [], filterSelectedAccesionNumber: [], filterStatus: [], searchByUserDetails: "", limit: 10, pageIndex: 1,
        }, () => {
            this.library_getReserveResourceRequests();
        })
    };

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
        this.setState({ dataHideWhileExporting: true })
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            exportSelectedCSVHeaders.push(csvInfo);
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // resource filter title on change
    handleSearchByUserDetailsChange = (event) => {
        this.setState({ pageIndex: 1, limit: 10, searchByUserDetails: event.target.value });
    };
    handleSearchByUserDetailsKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.library_getReserveResourceRequests();
        }
    };

    render() {
        return (
            <>
                <RoutingMenu activeScreen="reserveABookAdmin" />
                <div className="libraryComponents-container">
                    <div className="pb-5">
                        <div className='resourceHeader'>
                            <p className='vm_custom_title3' style={{ color: '#000000' }}>Reserve A Book</p>
                        </div>

                        <div>
                            <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                                <div className="taskContentRow" style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                        <div className="filteredInput mb-3  p-1">
                                            <label className="fs-14 fieldHeadColor">Accession Series</label>
                                            <Select
                                                options={Object.values(this.state.filterAccessionSeriesData)}
                                                value={this.state.filterSelectedAccessionSeries}
                                                className="basic-multi-select-filter"
                                                onChange={(event) => {
                                                    this.setState({
                                                        pageIndex: 1,
                                                        limit: "10",
                                                        filterSelectedAccessionSeries: event ? [event] : [], // 👈 force array
                                                        filterSelectedAccesionNumber: [],
                                                    }, () => {
                                                        if (this.state.filterSelectedAccessionSeries.length > 0) {
                                                            this.getFilterMultipleAccessionNoList();
                                                        }
                                                        this.library_getReserveResourceRequests();
                                                    });
                                                }}
                                                placeholder="Select Accession Series"
                                                isLoading={this.state.loadingFilterAccessionSeriesData}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        width: '100%',
                                                        minHeight: 42,
                                                        height: 'auto',
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                        color: state.isSelected ? '#333' : '#555',
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: '400',
                                                    }),
                                                }}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => (this.state.loadingFilterAccessionSeriesData ? "Loading..." : "No options found")}
                                            />
                                        </div>

                                        <div className="filteredInput mb-3  p-1">
                                            <label className="fs-14 fieldHeadColor">Accession Number</label>
                                            <Select
                                                options={this.state.filterAccessionNumberData}
                                                onChange={(event) => {
                                                    this.setState({
                                                        filterSelectedAccesionNumber: event || [],
                                                    }, () => {
                                                        this.library_getReserveResourceRequests();
                                                    })
                                                }}
                                                onInputChange={(inputValue) => {
                                                    this.setState({ filterSearchAccessionNo: inputValue }, () => {
                                                        if (this.state.filterSelectedAccessionSeries?.length > 0) {
                                                            this.getFilterMultipleAccessionNoList();
                                                        }
                                                    }, 200);
                                                }}
                                                isDisabled={!this.state.filterSelectedAccessionSeries || this.state.filterSelectedAccessionSeries.length === 0}
                                                value={this.state.filterSelectedAccesionNumber}
                                                isLoading={this.state.loadingFilterAccessionNumberData}
                                                placeholder="Select Accession Number"
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        width: '100%',
                                                        minHeight: 42,
                                                        height: 'auto',
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                        color: state.isSelected ? '#333' : '#555',
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: '400',
                                                    }),
                                                }}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => (this.state.loadingFilterAccessionNumberData ? "Loading..." : "No options found")}
                                            />
                                        </div>

                                        <div className="filteredInput mb-3  p-1">
                                            <label className="fs-14 fieldHeadColor">Status</label>
                                            <Select
                                                options={[
                                                    { label: 'Active', value: 'active' },
                                                    { label: 'Inactive', value: 'inactive' },
                                                    { label: 'Issued', value: 'issued' },
                                                    { label: 'Available', value: 'available' },
                                                    { label: 'Issued to others', value: 'issued_to_others' },
                                                    { label: 'Cancelled', value: 'cancelled' },
                                                ]}
                                                onChange={(event) => {
                                                    this.setState({
                                                        filterStatus: event || [],
                                                    }, () => {
                                                        this.library_getReserveResourceRequests();
                                                    })
                                                }}
                                                value={this.state.filterStatus}
                                                placeholder="Select Status"
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        width: '100%',
                                                        minHeight: 42,
                                                        height: 'auto',
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: 400,
                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                        color: state.isSelected ? '#333' : '#555',
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        fontSize: '12px',
                                                        fontWeight: '400',
                                                    }),
                                                }}
                                                menuPortalTarget={document.body}
                                            />
                                        </div>

                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="taskID" className="vm_custom_body5" color='#454E52'>Search By User Details</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <img
                                                    src={searchPng}
                                                    style={{
                                                        position: 'absolute',
                                                        left: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        color: '#ccc',
                                                        backgroundColor: 'white',
                                                        width: '18px',
                                                        height: '18px',
                                                        zIndex: 1,
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control formControlAutoTask"
                                                    id="resourceTitleFilterID"
                                                    placeholder="Search By ERP Id/ PRN Number/ Employee Id"
                                                    title='Search By ERP Id/ PRN Number/ Employee Id'
                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px' }}
                                                    value={this.state.searchByUserDetails} // Bind value to state
                                                    onChange={this.handleSearchByUserDetailsChange} // Handle input changes
                                                    onKeyPress={this.handleSearchByUserDetailsKeyPress} // Trigger API call on Enter
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end align-items-center" style={{ marginTop: '15px', gap: '10px' }}>
                                        {/* Click to Print */}
                                        <div title="Click to Print">
                                            <span className="print-button">
                                                <ReactToPrint
                                                    trigger={() => {
                                                        return (
                                                            <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                <style type="text/css" media="print">
                                                                    {"@page { size: auto; }"}
                                                                </style>
                                                                <span>
                                                                    <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                </span>
                                                            </div>
                                                        )
                                                    }}
                                                    content={() => this.componentRef}
                                                />
                                            </span>
                                        </div>

                                        {/* 1 action button - export data */}
                                        <div className="d-flex ml-2" title="Click to Export" >
                                            <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                            {/* 2.1 action button option - export and export all */}
                                            <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                <span>
                                                    <div style={{ display: 'none' }}>
                                                        <ReactHTMLTableToExcel
                                                            id="export"
                                                            className="btn outline-button waves-effect text-capitalize"
                                                            table="resourceList"
                                                            filename="Reserve A Book List"
                                                            sheet="tablexls"
                                                            buttonText="Export to Excel "
                                                        >
                                                        </ReactHTMLTableToExcel>
                                                    </div>

                                                    <button
                                                        onClick={() => {
                                                            this.setState({ dataHideWhileExporting: false }, () => {
                                                                this.formatCSVExportData()
                                                            })
                                                        }}
                                                        className="dropdown-item"
                                                        title="Click to Export"
                                                        style={{ boxShadow: 'none' }}
                                                    >
                                                        Export
                                                    </button>
                                                </span>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Press "Enter" to get list filter result.</p>
                            </div>
                            {
                                (this.state.filterSelectedAccessionSeries.length !== 0 || this.state.pageIndex !== 1 || this.state.limit !== 10 || this.state.filterSelectedAccesionNumber.length !== 0 || this.state.filterStatus.length !== 0 || this.state.searchByUserDetails !== "") &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllResourceFilter}>Clear All</p>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="col-md-12 px-0 div_table">
                        <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                            <div className="print-area" ref={el => this.componentRef = el}>
                                <div className="buildingReport_logo">
                                    <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                    <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                    <h3>Reserve A Book</h3>
                                </div>
                                <table className="table table-bordered  vm_libraryReport_table" id="resourceList">
                                    <thead style={{ backgroundColor: "#f2f3f4", position: 'sticky', top: '-1%' }}>
                                        <tr>
                                            <th scope="col">Sr. No.</th>
                                            <th scope="col">Accession Details</th>
                                            <th scope="col">Resource Title</th>
                                            <th scope="col">Resource Author</th>
                                            <th scope="col">User Details</th>
                                            {/* <th scope="col">Expected Date</th> */}
                                            <th scope="col">Added On</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Queue Number</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.accessMemberList ?
                                                <tr>
                                                    <Spinner />
                                                </tr>
                                                :
                                                Object.keys(this.state.membersList).length > 0 ?
                                                    Object.values(this.state.membersList).reverse().map((members, index) => {
                                                        return (
                                                            <>
                                                                <tr>
                                                                    <td style={{ padding: '0.5rem' }}>{this.state.offset + index + 1}</td>
                                                                    <td style={{ padding: '0.5rem' }}>{members?.resourceDetails?.accession_series_text + "_" + members?.resourceDetails?.accessionnumber}</td>
                                                                    <td style={{ padding: '0.5rem' }} title={members?.resourceDetails?.title}> {
                                                                        members?.resourceDetails?.title?.length > 20
                                                                            ? members.resourceDetails.title.slice(0, 20) + "..."
                                                                            : members?.resourceDetails?.title || ""
                                                                    }</td>
                                                                    <td style={{ padding: '0.5rem' }} title={members?.resourceDetails?.author}>{
                                                                        members?.resourceDetails?.author?.length > 20
                                                                            ? members.resourceDetails.author.slice(0, 20) + "..."
                                                                            : members?.resourceDetails?.author || ""
                                                                    }</td>
                                                                    <td style={{ padding: '0.5rem' }}>
                                                                        <div>
                                                                            <strong>
                                                                                User Name: {`${members?.userFirstName || ''} ${members?.userLastName || ''}`.trim()}
                                                                            </strong>
                                                                            <br />
                                                                            <strong>
                                                                                User ERP ID: {members?.userERPNo || '-'}
                                                                            </strong>
                                                                        </div>

                                                                        <div style={{ fontSize: '13px', color: '#555' }}>
                                                                            {
                                                                                members?.userRole === 'faculty'
                                                                                    ? `Employee ID: ${members?.EmployeeCode || '-'}`
                                                                                    : `PRN / University No: ${members?.userPRNNumber || '-'}`
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    {/* <td style={{ padding: '0.5rem' }}>{new Date(members?.available_date).toISOString().slice(0, 10)}</td> */}
                                                                    <td style={{ padding: '0.5rem' }}>{new Date(members?.added_on).toISOString().slice(0, 10)}</td>
                                                                    <td style={{ padding: '0.5rem' }}>{members?.status ? members.status.charAt(0).toUpperCase() + members.status.slice(1) : ""}</td>
                                                                    <td style={{ padding: '0.5rem' }}>{members?.queueNumber || ""}</td>
                                                                </tr>

                                                            </>
                                                        );
                                                    })
                                                    :
                                                    <tr>
                                                        <td style={{ padding: 5 }} colSpan={7}>No data found.</td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {
                            (Object.keys(this.state.membersList).length > 0 || Object.keys(this.state.accessMemberList).length > this.state.limit) &&
                            <div className='row px-0'>
                                <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                    <div className='row align-items-center justify-content-between'>
                                        <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                            <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                    <select className="mx-2 p-1 vm_select_border" name="pageSize" id="" value={this.state.limit} onChange={(e) => this.selectLimit(e)}>
                                                        <option value={10}>Entries Per Page 10</option>
                                                        <option value={25}>Entries Per Page 25</option>
                                                        <option value={40}>Entries Per Page 40</option>
                                                        <option value={100}>Entries Per Page 100</option>
                                                        <option value={250}>Entries Per Page 250</option>
                                                    </select>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                            <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                <Pagination
                                                    activePage={this.state.pageIndex}
                                                    itemsCountPerPage={this.state.limit}
                                                    totalItemsCount={this.state.totalMembers}
                                                    pageRangeDisplayed={3}
                                                    onChange={(num) => this.updatePaginationCount(num)}
                                                />
                                            </div>
                                        </div>
                                        {/* {
                                                                this.returnExportAllData()
                                                            } */}
                                        <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                            <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                Total Records : {this.state.totalMembers || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                </div>
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
            </>
        )
    }

}
const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin
    };
};

export default connect(mapStateToProps)(ReserveABookForAdmin);
